import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoDeclaracionJuradaCeseActividadDirecta = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoDeclaracionJuradaCeseActividadDirecta = () => {
  const [loadingGetInfoDeclaracionJuradaCeseActividadDirecta, setLoadingGetInfoDeclaracionJuradaCeseActividadDirecta] = useState(false);
  const [successGetInfoDeclaracionJuradaCeseActividadDirecta, setSuccessGetInfoDeclaracionJuradaCeseActividadDirecta] = useState(false);
  const [errorGetInfoDeclaracionJuradaCeseActividadDirecta, setErrorGetInfoDeclaracionJuradaCeseActividadDirecta] = useState<any>(null);
  const [dataGetInfoDeclaracionJuradaCeseActividadDirecta, setDataGetInfoDeclaracionJuradaCeseActividadDirecta] = useState<any>(null);

  const [statusGetInfoDeclaracionJuradaCeseActividadDirecta, setStatusGetInfoDeclaracionJuradaCeseActividadDirecta] =
    useState<StatusGetInfoDeclaracionJuradaCeseActividadDirecta>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoDeclaracionJuradaCeseActividadDirecta = async (
    userId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoDeclaracionJuradaCeseActividadDirecta(true);
    setSuccessGetInfoDeclaracionJuradaCeseActividadDirecta(false);
    setErrorGetInfoDeclaracionJuradaCeseActividadDirecta(null);

    try {
      const res = await apiRecord.getInfoDeclaracionJuradaDirecta(userId);

      setStatusGetInfoDeclaracionJuradaCeseActividadDirecta({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetInfoDeclaracionJuradaCeseActividadDirecta(true);
      setDataGetInfoDeclaracionJuradaCeseActividadDirecta(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetInfoDeclaracionJuradaCeseActividadDirecta({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetInfoDeclaracionJuradaCeseActividadDirecta(err);
      console.error("Error en getInfoDeclaracionJuradaCeseActividadDirecta:", err);

      throw err;

    } finally {
      setLoadingGetInfoDeclaracionJuradaCeseActividadDirecta(false);
    }
  };

  return {
    getInfoDeclaracionJuradaCeseActividadDirecta,
    loadingGetInfoDeclaracionJuradaCeseActividadDirecta,
    successGetInfoDeclaracionJuradaCeseActividadDirecta,
    errorGetInfoDeclaracionJuradaCeseActividadDirecta,
    dataGetInfoDeclaracionJuradaCeseActividadDirecta,
    statusGetInfoDeclaracionJuradaCeseActividadDirecta
  };
};

export default useGetInfoDeclaracionJuradaCeseActividadDirecta;
